<template>
  <div
    class="mx-auto max-w-7xl px-8 sm:px-none"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { defineOptions } from 'vue';

defineOptions({ inheritAttrs: true });
</script>
